import { useEffect } from 'react';
import { CustomerShippingAddress } from '../../../backend/openapi/api-types';
import { selectDeliveryAddress } from '../../../customer/services/select-delivery-address';
import isNil from '../../../../core/helpers/is-nil';
import { useShippingAddressId } from '../../../customer/hooks/use-shipping-address-id';

export const useDeliveryAddress = (shippingAddresses: CustomerShippingAddress[] | undefined) => {
  const { shippingAddressId, setShippingAddressId } = useShippingAddressId();
  const selectedDeliveryAddress = selectDeliveryAddress(shippingAddresses, shippingAddressId);

  useEffect(
    function updateShippingAddressId() {
      if (isNil(selectedDeliveryAddress?.addressId)) {
        return;
      }

      if (selectedDeliveryAddress.addressId === shippingAddressId) {
        return;
      }

      setShippingAddressId(selectedDeliveryAddress.addressId);
    },
    [selectedDeliveryAddress?.addressId, setShippingAddressId, shippingAddressId],
  );

  return { selectedDeliveryAddress, setShippingAddressId };
};
